// File: src/App.js
import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation, useNavigate } from 'react-router-dom';
import Login from './components/Login';
import AdminPanel from './components/Admin/AdminPanel';
import ReservationView from './components/ReservationView';
import ProtectedRoute from './ProtectedRoute';
import NavBar from './components/NavBar';
import ParkingSpotsView from './components/ParkingSpotsView';
import UserPanel from './components/UserPanel';
import MicrosoftCallback from './components/MicrosoftCallback';
import ConsentRequired from './components/ConsentRequired';
import { AuthContext } from './context/AuthContext';
import axios from './api/axiosInstance';

function AppRoutes({ user, setUser, consentRequired, setConsentRequired }) {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (
      location.pathname === '/login' ||
      location.pathname === '/auth/microsoft/callback' ||
       location.pathname === '/consent-required'
    ) return;

    const token = localStorage.getItem('token');
    if (!token) {
      setUser(null);
      setConsentRequired(false);
      return;
    }
    axios.get('/api/auth/me')
      .then(res => {
        setUser(res.data);
        setConsentRequired(false);
      })
      .catch(err => {
        if (
          err.response?.status === 403 &&
          err.response?.data?.requiresConsent
        ) {
          setConsentRequired(true);
          navigate('/consent-required');
        } else {
          setUser(null);
          setConsentRequired(false);
        }
      });
  }, [location.pathname, navigate, setUser, setConsentRequired]);

  return (
    <AuthContext.Provider value={{ user, setUser, consentRequired }}>
      <NavBar />
      <div className="container mt-4">
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/auth/microsoft/callback" element={<MicrosoftCallback />} />
          <Route path="/consent-required" element={<ConsentRequired />} />
          <Route path="/" element={<ProtectedRoute><ReservationView /></ProtectedRoute>} />
          <Route path="/spots" element={<ProtectedRoute><ParkingSpotsView currentUserId={user?.id} /></ProtectedRoute>} />
          <Route path="/user-panel" element={<ProtectedRoute><UserPanel /></ProtectedRoute>} />
          <Route path="/admin" element={<ProtectedRoute adminOnly={true}><AdminPanel /></ProtectedRoute>} />
          <Route path="*" element={<h3>404 - Strona nie istnieje</h3>} />
        </Routes>
      </div>
    </AuthContext.Provider>
  );
}

function App() {
  const [user, setUser] = useState(null);
  const [consentRequired, setConsentRequired] = useState(false);

  return (
    <Router>
      <AppRoutes
        user={user}
        setUser={setUser}
        consentRequired={consentRequired}
        setConsentRequired={setConsentRequired}
      />
    </Router>
  );
}

export default App;
